import React from 'react';

import { Tooltip } from '@material-ui/core';
import { StyledBox, StyledTypography } from 'styles/common';

import theme from 'constants/theme';

const HighlightedText = (props) => {
  const { text, tooltipMessage, tooltipPlacement, color = 'textPrimary', bgColor = 'grey' } = props;
  const disabledTooltip = tooltipMessage
    ? {}
    : { disableFocusListener: true, disableHoverListener: true, disableTouchListener: true };

  return (
    <Tooltip title={tooltipMessage} placement={tooltipPlacement || 'left'} {...disabledTooltip}>
      <StyledBox
        padding="0.5rem 2rem"
        bgcolor={theme.palette.background[bgColor]}
        borderRadius={4}
        flexcontainer
        justifycontent="center"
        alignitems="center"
      >
        <StyledTypography variant="body1" color={color} weight={600}>
          {text}
        </StyledTypography>
      </StyledBox>
    </Tooltip>
  );
};

export default HighlightedText;
